var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    stroke: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.5C15.8578 27.5 12.5 24.1422 12.5 20C12.5 15.8578 15.8578 12.5 20 12.5C24.1422 12.5 27.5 15.8578 27.5 20C27.5 24.1422 24.1422 27.5 20 27.5ZM18.2825 25.7502C17.5426 24.1807 17.1139 22.4827 17.0202 20.75H14.0465C14.1924 21.9042 14.6704 22.9911 15.4224 23.8788C16.1744 24.7664 17.168 25.4166 18.2825 25.7502ZM18.5225 20.75C18.6357 22.5792 19.1585 24.2975 20 25.814C20.8642 24.2574 21.3691 22.5271 21.4775 20.75H18.5225ZM25.9535 20.75H22.9797C22.8861 22.4827 22.4574 24.1807 21.7175 25.7502C22.832 25.4166 23.8256 24.7664 24.5776 23.8788C25.3296 22.9911 25.8076 21.9042 25.9535 20.75ZM14.0465 19.25H17.0202C17.1139 17.5173 17.5426 15.8193 18.2825 14.2498C17.168 14.5834 16.1744 15.2336 15.4224 16.1212C14.6704 17.0089 14.1924 18.0958 14.0465 19.25ZM18.5233 19.25H21.4767C21.3686 17.4729 20.864 15.7426 20 14.186C19.1358 15.7426 18.6309 17.4729 18.5225 19.25H18.5233ZM21.7175 14.2498C22.4574 15.8193 22.8861 17.5173 22.9797 19.25H25.9535C25.8076 18.0958 25.3296 17.0089 24.5776 16.1212C23.8256 15.2336 22.832 14.5834 21.7175 14.2498Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon3);
export default __webpack_public_path__ + "static/media/connect_icon3.9e83e06d1d530ef31d59cb18e8582617.svg";
export { ForwardRef as ReactComponent };